module.exports = __webpack_public_path__ + "static/media/reg-step-one.528d8129.webp";